import Env from '../config/envConfig'

import {
  FacebookPostApi as FacebookPostApiClass,
  LinkedInPostApi as LinkedInPostApiClass,
  FacebookPageApi as FacebookPageApiClass,
  InstagramPostApi as InstagramPostApiClass,
  InstagramPageApi as InstagramPageApiClass,
  GooglePostApi as GooglePostApiClass,
  GooglePageApi as GooglePageApiClass,
  TagApi as TagApiClass,
  AboTopicsApi as AboTopicsApiClass,
  PostApi as PostApiClass,
  PostTemplateApi as PostTemplateApiClass,
  DeferredPostApi as DeferredPostApiClass,
  MediaFileApi as MediaFileApiClass,
  IndividualizationApi as IndividualizationApiClass,
  Configuration as SMConfiguration,
  UrlInformationExtractorApi as UrlInformationExtractorApiClass,
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from './smModuleFetchApi'

const BASE_PATH_API = Env.restBase

export const FacebookPostApi = new FacebookPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const FacebookPageApi = new FacebookPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPostApi = new InstagramPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPageApi = new InstagramPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const GooglePostApi = new GooglePostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const GooglePageApi = new GooglePageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const LinkedInPostApi = new LinkedInPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const IndividualizationApi = new IndividualizationApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const TagApi = new TagApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const AboTopicsApi = new AboTopicsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PostApi = new PostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const DeferredPostApi = new DeferredPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PostTemplateApi = new PostTemplateApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const MediaFileApi = new MediaFileApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const UrlInformationExtractorApi = new UrlInformationExtractorApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

